// Module
var code = `<!-- blHeading level 2 — see bl-heading-3.tmpl.html for level 3.
     Data shape: { level: 2, text: "inline HTML", headingId?: "kebab-id" }
     Separate per-level templates because DomElementTemplate can neither
     emit dynamic tag names nor resolve placeholders inside boolean
     sections. Real h2/h3 tags are required by the article view's
     anchor-link feature (article.blog h2[id], h3[id]). -->
<h2 id="{{headingId}}">{{text}}</h2>
`;
// Exports
module.exports = code;